'use strict';

var transportList = require('./transport-list');

module.exports = require('./main')(transportList);

// TODO can't get rid of this until all servers do
if ('_sockjs_onload' in global) {
  setTimeout(global._sockjs_onload, 1);
}



//////////////////
// WEBPACK FOOTER
// ./~/sockjs-client/lib/entry.js
// module id = O3w4
// module chunks = 29